/**
 * Builds a File from the same shape used by {@link sendEmail} attachments (base64 body, no data URL prefix).
 */
export const emailAttachmentBlobToFile = (a: {
  filename: string;
  content: string;
  contentType: string;
}): File => {
  const binary = atob(a.content);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], a.filename, { type: a.contentType });
};
